import { format, addDays } from 'date-fns';

// Check-in 16:00 − 6 ώρες προθεσμία → κράτηση ίδιας μέρας μόνο έως 10:00 ώρα Ελλάδας
const SAME_DAY_CUTOFF_MINUTES = 10 * 60;
// Ελάχιστη διαμονή αν δεν έχει φορτώσει η τιμή από Smoobu/PriceLabs
export const DEFAULT_MIN_STAY = 2;

// Τρέχουσα ημερομηνία ('yyyy-MM-dd') και λεπτά από μεσάνυχτα σε ώρα Ελλάδας,
// ανεξάρτητα από τη ζώνη ώρας του browser του επισκέπτη
const athensNow = () => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Athens',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .map((p) => [p.type, p.value])
  );
  return {
    today: `${parts.year}-${parts.month}-${parts.day}`,
    minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10),
  };
};

// true αν η ημέρα ΔΕΝ μπορεί να είναι check-in λόγω χρόνου:
// παρελθόν, ή σήμερα μετά τις 10:00 Ελλάδας. Μελλοντικές μέρες πάντα ανοιχτές.
export const isTooLateForCheckIn = (date) => {
  const { today, minutes } = athensNow();
  const day = format(date, 'yyyy-MM-dd');
  if (day < today) return true;
  if (day === today) return minutes > SAME_DAY_CUTOFF_MINUTES;
  return false;
};

// Ελάχιστες νύχτες για άφιξη στη συγκεκριμένη ημέρα (min_length_of_stay από /api/min-stays)
export const minStayFor = (minStays, checkIn) =>
  (checkIn && minStays[format(checkIn, 'yyyy-MM-dd')]) || DEFAULT_MIN_STAY;

// true αν η ημέρα είναι ανάμεσα στο check-in και στο νωρίτερο επιτρεπτό check-out
export const isWithinMinStay = (minStays, checkIn, date) =>
  !!checkIn && date > checkIn && date < addDays(checkIn, minStayFor(minStays, checkIn));
